import React from "react";
import SVGBroken1 from "../../Misc/SvgIcons/SVGBroken1";
import SVGDocument1 from "../../Misc/SvgIcons/SVGDocument1";
import SVGDocument2 from "../../Misc/SvgIcons/SVGDocument2";
import SVGMaint from "../../Misc/SvgIcons/SVGMaint";
import SVGOrder1 from "../../Misc/SvgIcons/SVGOrder1";
import SVGRequest1 from "../../Misc/SvgIcons/SVGRequest1";
import SVGTake from "../../Misc/SvgIcons/SVGTake";
import SVGTransfer1 from "../../Misc/SvgIcons/SVGTransfer1";
import SVGWrench1 from "../../Misc/SvgIcons/SVGWrench1";
import SVGList from "../../Misc/SvgIcons/SVGList";
import SVGOil from "../../Misc/SvgIcons/SVGOil";
import SVGBarrel from "../../Misc/SvgIcons/SVGBarrel";
import SVGDial1 from "../../Misc/SvgIcons/SVGDial1";

const typedoc = [
  {
    key: "template",
    icon: <SVGDocument2 />,
    iconColor: "muted",
    searchLabel: "Шаблоны",
  },
  {
    key: "manual",
    icon: <SVGDocument1 />,
    iconColor: "primary",
    searchLabel: "Руководства и инструкции",
  },
  {
    key: "workdoc",
    icon: <SVGDocument1 />,
    iconColor: "secondary",
    inWorkdoc: true,
    searchLabel: "Рабочие документы",
  },

  {
    key: "request",
    label: "Заявка",
    description: "Заявка на поставку ТМЦ и запасных частей",
    searchLabel: "Заявки",
    icon: <SVGRequest1 />,
    iconColor: "success",
    url: "/request/add",
    cartObjects: "model",
    inCart: true,
    inProduct: true,
    inTypedocList: true,
    inWorkdoc: true,
  },
  {
    key: "order",
    label: "Акт приема",
    description: "Приходный ордер, форма М-4",
    searchLabel: "Акты приема",
    icon: <SVGOrder1 />,
    iconColor: "primary",
    url: "/order/add",
    cartObjects: "model",
    inCart: true,
    inProduct: true,
    inTypedocList: true,
    inWorkdoc: true,
  },
  {
    key: "fda",
    label: "Акт дефектации",
    searchLabel: "Акты неисправности",
    description: "Акт обнаружения неисправности",
    icon: <SVGMaint />,
    iconColor: "info",
    url: "/fda/add",
    inCart: false,
    inProduct: false,
    inTypedocList: true,
    inWorkdoc: true,
  },
  {
    key: "troubleshooting",
    label: "Акт дефектации",
    searchLabel: "Акты дефектации",
    description: "Дефектация деталей и оборудования",
    icon: <SVGMaint />,
    iconColor: "info",
    inWorkdoc: true,
  },
  {
    key: "cancellation",
    label: "Акт списания",
    searchLabel: "Акты списания",
    description: "Списание ТМЦ из судовых запасов",
    icon: <SVGBroken1 />,
    iconColor: "warning",
    url: "/delivery/cancellation/add",
    cartObjects: "product",
    inCart: true,
    inProduct: true,
    inTypedocList: true,
    inWorkdoc: true,
  },
  {
    key: "installation",
    label: "Акт установки",
    searchLabel: "Акты установки",
    description: "Установка запасных частей и оборудования",
    icon: <SVGWrench1 />,
    iconColor: "warning",
    url: "/delivery/installation/add",
    cartObjects: "product",
    inCart: true,
    inProduct: true,
    inTypedocList: true,
    inWorkdoc: true,
  },

  {
    key: "waybill",
    label: "Накладная",
    searchLabel: "Накладные",
    description: "Накладная по форме М-11",
    icon: <SVGTransfer1 />,
    iconColor: "info",
    url: "/delivery/waybill/add",
    cartObjects: "product",
    inCart: true,
    inProduct: true,
    inTypedocList: true,
    inWorkdoc: true,
  },
  {
    key: "undertake",
    label: "Акт заведования",
    searchLabel: "Акты заведования",
    description: "Акт приема заведования",
    icon: <SVGTake />,
    iconColor: "primary",
    url: "/undertake/add",
    inCart: false,
    inProduct: false,
    inTypedocList: true,
    inWorkdoc: true,
  },
  {
    key: "repair",
    label: "Ремонтная ведомость",
    searchLabel: "Ремонтные ведомости",
    description: "",
    icon: <SVGList />,
    iconColor: "info",
    url: "/repair/add",
    inCart: false,
    inProduct: false,
    inTypedocList: true,
    inWorkdoc: true,
  },
  {
    key: "bunker",
    label: "Заявка на бункеровку",
    searchLabel: "Заявки на бункеровку",
    description: "Заявка на бункеровку",
    icon: <SVGBarrel />,
    iconColor: "success",
    url: "/bunkerorder/add",
    inCart: false,
    inProduct: false,
    inTypedocList: true,
    inWorkdoc: true,
  },
  {
    key: "act_maintenance",
    label: "Акт выполнения ТО",
    searchLabel: "Акты выполнения ТО",
    description: "Акт выполнения технического обслуживания",
    icon: <SVGOil />,
    iconColor: "primary",
    url: "/act_maintenance/add",
    inCart: false,
    inProduct: false,
    inTypedocList: true,
    inWorkdoc: true,
  },
  {
    key: "timesheet",
    label: "Табель",
    description: "Табель учета рабочего времени",
    searchLabel: "Табель",
    icon: <SVGDial1 />,
    iconColor: "warning",
    url: "/timesheet/add",
    inTypedocList: true,
    inWorkdoc: true,
  },
];
export function getTypedocByKey(key) {
  return typedoc.find((item) => item.key === key) || {};
}
export function getKeysByCriteria(criteria) {
  let result = [];
  typedoc.forEach((item) => {
    if (item[criteria]) result.push(item.key);
  });
  return result;
}
export default typedoc;
